

<template>
  <div class="toolbar">
    <div class="col-1 float-right">
      <new-menu-app></new-menu-app>
    </div>
<!--    <back-icon></back-icon>-->
    <search-icon></search-icon>

    <div class="col-5 float-left">
      <v-img
          :src="require('../assets/logohome.png')"

          contain
          height="35"
      />
    </div>


  </div>
  <v-main class="main" >
    <pic-link></pic-link>

    <new-category showTitle="true"></new-category>
    <div class="clearfix"></div>
    <div class="col-12 hrr" style="background: rgb(215, 215, 215);padding: 10px;position: absolute;width: 100vw;right: 0px;bottom: 70px;">

      <div class="col-6 float-right text-center">
        <a href="https://trustseal.enamad.ir/?id=550095&Code=MioS8nnmDvccxxgvKJeahCL2NIm70u3x" target="_blank">
          <img
              :src="require('../assets/enamd.png')"
              width="30%"


          />
          <br/>
          نماد اعتماد
        </a>

      </div>
      <div class="col-6 float-right text-center">
        <img
            :src="require('../assets/pay-icon.png')"
            width="30%"


        />
        <br/>
        پرداخت امن
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="clearfix"></div>
    <footer-app selectedItem="2" :badgeCart="badgeCart"></footer-app>
    <div class="clearfix"></div>
  </v-main>

</template>
<script >

import PicLink from "@/components/PicLink.vue";
import Products from "@/components/Products.vue";
import NewProducts from "@/components/NewProducts.vue";
import NewMenuApp from "@/components/newMenuApp.vue";
import NewCategory from "@/components/NewCategory.vue";
import FooterApp from "@/views/FooterApp.vue";
import {CurvedBottomNavigation} from "bottom-navigation-vue";
import http from "@/plugins/axios";
import router from "@/router";
import SearchIcon from "@/components/searchIcon.vue";
import BackIcon from "@/components/backIcon.vue";
import { useCacheCleaner } from "@/composables/useCacheCleaner";

const { clearPWAAppCache } = useCacheCleaner();
export default {
  components: {
    BackIcon,
    SearchIcon, CurvedBottomNavigation,FooterApp,NewCategory,NewMenuApp,NewProducts,Products,PicLink},
  name: 'new-home',
  data: () => ({
    badgeCart: 0,
    searchdialog : false,
    search : {
      data : []
    },
    value_search : "",
  }),
  methods:{
    getVersion(){
      let version = localStorage.getItem("version");
      http.get("/version")
          .then(response => {
            // version = response.data.data.version;
            if(version == response.data.data.version){

            }else{
              localStorage.setItem("version",response.data.data.version);
              let version = localStorage.getItem("version");
              alert("در حال بروز رسانی آپ");
              clearPWAAppCache();
            }

            // alert("2225");

          })
          .catch((error) => {
          });
    },
    getCart() {
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/basket/get", { headers: { Authorization: AuthStr } })
          .then(response => {
            this.badgeCart = response.data.data.items.length;
          })
          .catch((error) => {
          });
    },
  },
  mounted () {
    this.getCart();
    this.getVersion();
  },
}
</script>
<style scoped>
.search{
  text-align: center;
  margin-top: 5px;
}
.search i{
  font-size: 14pt !important;
}
.toolbar{
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000000;
  direction: rtl;
  padding: 20px 30px;
  color: #fff;
  background: #fff;
}
.toolbar i{
  font-size: 24pt;
  color: #1fa29d;
}
.toolbar .col-9{
  padding-right: 10px;
}
.main{
  padding: 100px 30px;
  height: calc(100% +100px);
}
.hrr a{
  color: #000;
  text-decoration: none;
}
</style>